'use client'

import styles from './global-error.module.scss'

const GlobalError = () => (
  <html lang='en'>
    <body className={styles.body}>
      <h1 className={styles.heading}>Application Error</h1>
      <p className={styles.message}>Something went wrong while loading EDHREC. The error has been recorded.</p>
      <div className={styles.actions}>
        <button className={styles.button} onClick={() => window.location.reload()} type='button'>
          Try again
        </button>
      </div>
    </body>
  </html>
)

export default GlobalError
